let grecaptcha = window.grecaptcha || {};

window.ambassadorOnloadCallback = () => {
  const recaptchaVisible = document.getElementById('recaptcha_visible');
  if (recaptchaVisible) {
    grecaptcha.render('recaptcha_visible', {
      sitekey: '6LdU3CgUAAAAAB0nnFM3M3T0sy707slYYU51RroJ',
    });
  }
};

export default () => {
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (target && target.getAttribute('data-input-toggle') !== null) {
      const inputToggle = target;
      const indicatorBox = inputToggle.querySelector('[data-input-toggle-indicator]');
      const inputField = inputToggle.nextElementSibling;
      indicatorBox.classList.toggle('selected');
      inputField.classList.toggle('revealed');

      if (inputField.classList.contains('revealed')) {
        inputField.setAttribute('data-required', true);
        inputField.focus();
      } else {
        inputField.removeAttribute('data-required');
        inputField.blur();
      }
    }
  });
};
